import { ButtonLink } from 'component-library';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { usePathSet } from '@/hooks/usePathSet';
import { buildPath } from '@/utils/buildPath';

import { usePlotGroupId } from './PlotGroups/PlotGroupsContextProvider';

export const ImpactProjectionsLink = () => {
  const { t } = useTranslation();
  const pathname = useLocation();
  const pathSet = usePathSet();
  const plotGroupId = usePlotGroupId();

  // TODO: TEMP FIX - Remove this early return when Impact Projections is fixed
  return null;

  // eslint-disable-next-line no-unreachable
  return (
    <ButtonLink
      to={buildPath(pathSet.impactProjections, { queryParams: { plotGroupId } })}
      state={{
        previousPath: pathname,
      }}
      variant='outline'
      className='w-fit'
    >
      {t('shared.ncaDetail.details.labels.impactProjectionsLink')}
    </ButtonLink>
  );
};
